import { COPY_STRINGS } from "../constants/translatedCopy";
import { generateSayWordSpelledMakesWordString } from "./interventionStringGenerators";

/**
 * Ok, "spells the word" makes "say the word".
 * Example: Word = "Flower"
 * Speech: "Ok, F l o w e r, makes Flower"
 */
export function spellAndSayTheWord(speech, word, callback) {
    speech.speak({
        textToSpeak: generateSayWordSpelledMakesWordString(word),
        passThroughSpeechTags: true,
        onEnd: callback,
    });
}

/**
 * Bilingual version of the sayWordSpelledMakesWord function,
 */
export function spellAndSayTheWordBilingual(speech, word, callback) {
    speech.speak({
        textToSpeak: generateSayWordSpelledMakesWordString(word),
        skipTranslation: true,
        passThroughSpeechTags: true
    }, undefined, undefined, true);
    speech.speak({
        textToSpeak: COPY_STRINGS.
            intervention_strings.makes
    });
    speech.speak({
        textToSpeak: word,
        skipTranslation: true,
        onEnd: callback
    });
}